import { User } from '../../../types/User';
import { showAlert } from '@silverfort/sf-components';
import { useUpdateUsers } from '../../../api';
import { useUsersActionPopup } from './useUserActionPopup';
import { useCallback } from 'react';
interface UseSetExternalEmailPopupParams {
    users: User[];
    onSetExternalEmail?: () => void;
}

interface UseSetExternalEmailPopupReturnType {
    openSetExternalEmailPopup: () => void;
}

export const useSetExternalEmailPopup = ({
    users,
    onSetExternalEmail
}: UseSetExternalEmailPopupParams): UseSetExternalEmailPopupReturnType => {
    const handleRevert = () => {
        updateUsers(users.map(({ guid }) => ({ guid, isExternalEmail: true })));
    };

    const { openUsersActionPopup, closePopup } = useUsersActionPopup({
        text: 'Are you sure you want to set these emails as external emails?',
        users,
        onAction: handleRevert,
        title: 'Set as external email'
    });

    const handleSuccess = useCallback(() => {
        closePopup();
        showAlert('User external email has been updated', 'success', {
            title: 'External email updated'
        });
        onSetExternalEmail?.();
    }, [closePopup, onSetExternalEmail]);

    const handleError = useCallback(() => {
        closePopup();
        showAlert('User external email failed to update', 'error', {
            title: 'Failed to update external email'
        });
    }, [closePopup]);

    const { updateUsers } = useUpdateUsers({
        onSuccess: handleSuccess,
        onError: handleError
    });

    return {
        openSetExternalEmailPopup: openUsersActionPopup
    };
};
